module.exports = require('./lib/index.js');



//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-optimist/index.js
// module id = 270
// module chunks = 0